import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../../services/api";
import { Spin, Button, Pagination, Modal, Select, Input } from "antd";
import {
  MdAttachMoney,
  MdAccountBalanceWallet,
  MdReceipt,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getValue } from "../../../services/functions";
import format from "date-fns/format";
import { InputMask, Message, ViewInput } from "../../../GlobalStyles";
import { useAuth } from "../../../hooks/AuthContext";
import { toast } from "react-toastify";

const { Option } = Select;

export default function PagamentosAssociado() {
  const navigate = useNavigate();
  const { user, editUser } = useAuth();
  const [payments, setPayments] = useState([]);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [paymentsTotalValue, setPaymentsTotalValue] = useState(0);
  const [type_pix, setType_pix] = useState(user?.type_pix || "");
  const [key_pix, setKey_pix] = useState(user?.key_pix || "");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [page, setPage] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadPayments();
  }, [page]);

  async function loadPayments() {
    setIsLoading(true);
    await api
      .get(`/payments/associate?page=${page}`)
      .then((response) => {
        setPayments(response.data.payments);
        setPaymentsTotal(response.data.paymentsTotal);
        setPaymentsTotalValue(response.data.paymentsTotalValue);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function editPix() {
    setIsLoadingModal(true);
    const data = new FormData();
    data.append("type_pix", type_pix);
    data.append("key_pix", key_pix);

    api
      .put(`/associate`, data)
      .then((response) => {
        toast.success("Chave PIX editada com sucesso");
        editUser({ user: response.data });
        setVisibleModal(false);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  const getPixMask = () => {
    switch (type_pix) {
      case "CPF":
        return "999.999.999-99";
      case "CNPJ":
        return "99.999.999/9999-99";
      case "Telefone":
        return "(99) 99999-9999";
      default:
        return "";
    }
  };

  return (
    <Container>
      <div className="dashboard-header">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 15,
            marginBottom: 25,
          }}
        >
          <h1 style={{ margin: 0 }}>Meus Pagamentos</h1>
          <div
            style={{
              backgroundColor: "#00803722",
              color: "#008037",
              padding: "4px 12px",
              borderRadius: 50,
              fontSize: 13,
              fontWeight: "bold",
            }}
          >
            Total: {paymentsTotal}
          </div>
        </div>
        <Button
          type="primary"
          icon={<MdAccountBalanceWallet size={18} />}
          onClick={() => setVisibleModal(true)}
          style={{
            backgroundColor: "#008037",
            borderColor: "#008037",
            borderRadius: 50,
            height: 40,
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontWeight: "bold",
            marginBottom: 25,
          }}
        >
          Configurar Chave PIX
        </Button>
      </div>

      {isLoading ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: 100 }}
        >
          <Spin size="large" color="#008037" />
        </div>
      ) : (
        <>
          <div className="main-tags">
            <div className="tag-item highlight">
              <div className="tag-header">
                <MdAttachMoney size={20} /> Total Já Recebido
              </div>
              <span className="value">{getValue(paymentsTotalValue)}</span>
            </div>
          </div>

          <h2 className="section-title">Histórico de Recebimentos</h2>

          {payments.length > 0 ? (
            <div className="payments-list">
              {payments.map((payment) => (
                <div className="payment-card" key={payment.id}>
                  <div className="main-info">
                    <strong>{payment.description}</strong>
                    <span>Pagamento via PIX</span>
                  </div>

                  <div className="date-info">
                    <label>Recebido em</label>
                    {format(new Date(payment.create_at), "dd/MM/yyyy")}
                  </div>

                  <div>
                    <div className="status-badge">Pago</div>
                  </div>

                  <div className="value-info">{getValue(payment.value)}</div>
                </div>
              ))}

              <Pagination
                style={{
                  margin: "30px 0",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
                current={1}
                total={paymentsTotal}
                pageSize={10}
                onChange={(page) => {
                  setPage(page);
                }}
              />
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
              }}
            >
              <MdReceipt size={50} color="#ccc" style={{ marginBottom: 15 }} />
              <Message>Nenhum pagamento encontrado.</Message>
            </div>
          )}
        </>
      )}
      <Modal
        title="Editar Chave PIX"
        open={visibleModal}
        cancelText="Cancelar"
        onCancel={() => setVisibleModal(false)}
        onOk={editPix}
        confirmLoading={isLoadingModal}
        okText="Salvar Alterações"
      >
        <div
          style={{
            marginTop: 20,
            borderTop: "1px solid #f0f0f0",
            paddingTop: 20,
          }}
        >
          <ViewInput>
            <p>Tipo de Chave</p>
            <Select
              style={{ width: "100%" }}
              value={type_pix}
              onChange={(value) => {
                setType_pix(value);
                setKey_pix("");
              }}
              placeholder="Selecione o tipo"
            >
              <Option value="CPF">CPF</Option>
              <Option value="CNPJ">CNPJ</Option>
              <Option value="E-mail">E-mail</Option>
              <Option value="Telefone">Telefone</Option>
              <Option value="Chave Aleatória">Chave Aleatória</Option>
            </Select>
          </ViewInput>
          <ViewInput>
            <p>Chave PIX</p>
            {!type_pix ||
            type_pix === "E-mail" ||
            type_pix === "Chave Aleatória" ? (
              <Input
                value={key_pix}
                onChange={(e) => setKey_pix(e.target.value)}
                placeholder="Digite sua chave PIX"
                disabled={!type_pix}
              />
            ) : (
              <InputMask
                mask={getPixMask()}
                maskChar=""
                value={key_pix}
                onChange={(e) => {
                  const val =
                    type_pix === "Telefone" ||
                    type_pix === "CPF" ||
                    type_pix === "CNPJ"
                      ? e.target.value.replace(/[^0-9]/g, "")
                      : e.target.value;
                  setKey_pix(val);
                }}
                placeholder="Digite sua chave PIX"
                disabled={!type_pix}
              />
            )}
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
